<template>
  <div id="app">
    <div class="headbox">
      <div style="display: flex;">
        <div class="logobox" >
          <img src="../../static/img/logo.png" style="height: 70px;" href="https://www.slfangshuijiao.com">
        </div>
        <div class="menu-top" style="width: 70%">
          <el-menu :default-active="activeIndex" class="el-menu-demo" text-color="#00000" active-text-color="#77AE2C"
                   menu-trigger="hover" mode="horizontal">
            <div v-for="(item,index) in columnData" :key="item.menuId" :index="item.menuId + ''" @click="openUrl(item)">
              <!-- 没有子菜单 -->
              <template v-if="!item.children ">
                <el-menu-item :index="item.menuId+ ''">
                  <template slot="title">
                    {{ item.menuName }}
                  </template>
                </el-menu-item>
              </template>
              <!-- 有子菜单 -->
              <el-submenu v-else :index="item.menuId+ ''">
                <template slot="title">
                  {{ item.menuName }}
                </template>
                <template v-for="(child,childIndex) in item.children">
                  <el-menu-item :key="child.menuId" :index="child.menuId+ ''"
                                @click="menuList(child,child.menuId,item,childIndex)">
                    {{ child.menuName }}
                  </el-menu-item>
                </template>
              </el-submenu>
            </div>
          </el-menu>
        </div>
        <div style="line-height: 70px;">
          <span>
                  <el-popover
                      placement="bottom-end"
                      width="400"
                      trigger="click">
                  <el-input placeholder="请输入内容" v-model="param" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchTitle"></el-button>
                  </el-input>
                    <i class="el-icon-search searchbox" slot="reference"></i>
                </el-popover>
          </span>
        </div>
        <el-dropdown trigger="click">
          <el-button type="primary">
            菜单栏<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" >
            <div v-for="(item,index) in columnData" :key="item.menuId" :index="item.menuId + ''" @click="openUrl(item)">
            <el-dropdown-item>{{ item.menuName }}</el-dropdown-item>
<!--            <el-dropdown-item>狮子头</el-dropdown-item>-->
<!--            <el-dropdown-item>螺蛳粉</el-dropdown-item>-->
<!--            <el-dropdown-item>双皮奶</el-dropdown-item>-->
<!--            <el-dropdown-item>蚵仔煎</el-dropdown-item>-->
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!--    中间-->
    <div class="container" style="clear: both;">
      <router-view></router-view>
    </div>
    <!--			侧边栏-->
    <div class="cbbox">
      <img src="../../static/img/zxzx.png" @click="openDialog" class="cbtb">
      <img src="../../static/img/qq.png" class="cbtb" slot="reference" @click="openqq">
      <el-popover
          placement="left"
          trigger="hover">
        <div>
          <img src="../../static/img/gongzhonghao.jpg" alt="" width="200px" height="200px">
        </div>
        <img src="../../static/img/wxzx.png" class="cbtb" slot="reference">
      </el-popover>
      <el-popover
          placement="left"
          trigger="hover">
        <div>
          <img src="../../static/img/55874c7f1c7bbdee071cd6b3207e0ba.jpg" alt="" width="200px" height="200px">
        </div>
        <img src="../../static/img/qqzx.png" class="cbtb" slot="reference">
      </el-popover>
      <img src="../../static/img/fhsy.png" class="cbtb" @click="toTop">
    </div>
    <!--    底部-->
    <div class="footbox">
      <div class="msgbox">
        <div class="linkbox1">
          <div class="msgtitle">公司地址</div>
          <div class="mas">
          <div class="msgsname">湖南神力胶业集团有限公司</div>
          <div>湖南省长沙(浏阳) 国家生物医药园蓝思一路 2 号</div>
          </div>
          <div class="mas">
          <div class="msgsname">湖南省神力建筑胶粘剂技术研究院</div>
          <div>湖南省长沙(浏阳) 国家生物医药园蓝思一路 2 号</div>
        </div>
          <div class="mas">
            <div class="msgsname">福建神力石材胶粘剂技术研究所</div>
            <div>福建省泉州市南安市石井镇下房村村口</div>
          </div>
          <div class="mas">
            <div class="msgsname">江西神力树脂新材料有限公司</div>
            <div>江西省修水县工业园太阳升项目区</div>
          </div>
        </div>
        <div class="linkbox1">
          <div class="msgtitle1"></div>
          <div class="mas">
            <div class="msgsname">湖南神力胶业集团有限公司项城分公司</div>
            <div>河南省周口市项城市千佛阁平安大道与任营路交叉口往西二十五米路南</div>
          </div>
          <div class="mas">
            <div class="msgsname">项城市神力防水工程有限公司</div>
            <div>河南省周口市项城市千佛阁平安大道与任营路交叉口往西二十五米路南</div>
          </div>
          <div class="mas">
            <div class="msgsname">湖南神力胶业集团有限公司福建分公司</div>
            <div>福建省泉州市南安市石井镇下房村村口</div>
          </div>
          <div class="mas">
            <div class="msgsname">湖南神力铃胶粘剂制造有限公司云浮分公司</div>
            <div>云浮市云城区安塘街道办右侧商铺-楼两卡铺位 (含横门)及三楼全层</div>
          </div>
        </div>
        <div class="linkbox">
          <div class="msgtitle">友情链接</div>
          <div class="mas">
          <div class="msgsname" v-for="item in linkData" @click="openfUrl(item.outsideUrl)">{{ item.outsideName }}</div>
          </div>
        </div>
      </div>
      <div class="copyright">
        <div class="copytit">版权所有，仿冒必究 湖南省神力胶业集团有限公司</div>
        <div class="copytit">客服热线:400-886-9622</div>
        <div class="copytit"><a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #FFFFFF">湘CP备2021014948号-2</a>
        </div>
      </div>
    </div>
<!--   手机版-->
    <div class="sjdb">
      <div class="h_foot1"> <div class="h_foot1_in">
        <p>如果您有任何问题，请跟我们联系！</p>
        <a class="lxwm" @click="lxwm()">
          <p>联系我们</p>
          <span></span></a>
      </div>
      </div>
      <div class="footer">
        <div class="wp">
          <div class="fd-top">
            <div class="fd-qr">
              <div class="pic"> <img src="../../static/img/gongzhonghao.jpg"> </div>
              <h3>扫一扫关注公众号</h3>
            </div>
            <div class="fd-qr">
            <div class="pic"> <img src="../../static/img/55874c7f1c7bbdee071cd6b3207e0ba.jpg"> </div>
            <h3>扫一扫关注抖音号</h3>
          </div>
          </div>
          <div class="linkbox">
            <div class="msgtitle">友情链接</div>
            <div class="mas">
              <div class="msgsname" v-for="item in linkData" @click="openfUrl(item.outsideUrl)">{{ item.outsideName }}</div>
            </div>
          </div>
        </div>
        <div class="copy">
          <div class="wp">
            <p style="font-size: x-large;" href="tel:400-886-9622">电话：400-886-9622</p>
            <p>地址：湖南省长沙(浏阳) 国家生物医药园蓝思一路 2 号</p>
            <p>Copyright 1989-2023 湖南省神力胶业集团有限公司 版权所有
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">湘CP备2021014948号-2</a>
            </p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
<!--    弹窗-->
    <el-dialog title="神力胶业集团 " :visible.sync="zxDialog" width="30%" :before-close="handleClose" class="zxbox"
               :modal="false">
      <div slot="title" class="dialog-header-title">
        <div><img src="../../static/img/zxtTitle.png" style="width: 50px;"/></div>
        <div class="zxname">神力胶业集团</div>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="您的联系方式？" prop="phone">
          <el-input v-model="ruleForm.phone" maxlength="11"
                    oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="留言内容" prop="content">
          <el-input type="textarea" v-model="ruleForm.content" placeholder="请输入留言内容"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="ruleForm.code" style="width: calc(100% - 107px)"></el-input>
          <div style="float: right;"><img ref="vcImg" :src="api + '/site/captchaImage?uuid=' + this.uuid " alt="验证码"
                                          @click="getVerifyCode()" style="height: 40px;"/></div>
        </el-form-item>
        <el-form-item>
          <el-button @click="zxSubmit('ruleForm')">提交</el-button>
          <!--           <el-button @click="resetForm('ruleForm')">重置</el-button>-->
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>


let api = 'https://www.slfangshuijiao.com/api';
let deptId = 111;
export default {
  name: 'Layout',
  data() {
    return {
      param: '',
      api,
      activeIndex: '1',
      rules: {
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,


            message: '请输入正确的手机号码',
          },
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
        ]
      },
      uuid: Math.floor(Math.random() * 10 + 1),
      columnData: [],
      linkData: [],
      ruleForm: {},
      input3: "",
      zxDialog: false,
    }
  },
  created() {
  },
  mounted() {
    this.lmList()
    this.linkList()
    this.codeList()
  },
  methods: {
    //跳转QQ客服
    openqq() {
      window.open(this.qq)
    },
    //返回顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    // 在线咨询弹窗
    openDialog() {
      this.zxDialog = true
    },
    handleClose() {
      this.zxDialog = false
    },
    cleanForm() {
      this.ruleForm = {
        phone: '',
        content: '',
        code: '',

      }
    },
    //全站搜索
    searchTitle() {
      if (this.param) {
        window.location = '/#/search?param=' + this.param;
        window.location.reload();

      } else {
        this.$message.error("请输入搜索内容")
      }

      /*let that = this;
      that.$axios.post(api + '/site/globalSearch?deptId=' + deptId + '&param=' + this.param , {
        emulateJSON: true
      }).then(function (res) {
        console.log(99999999, res.data.data);
        if (res.data.code == '0') {
          // that.linkData = res.data.data
        } else {
          that.$message.error(res.data.msg);
        }
      })*/
    },
    lxwm(){
      window.location = '/#/ejml?id=122&name=联系我们'
      document.documentElement.scrollTop = 0;
      location.reload();
    },
    codeList() {
      let that = this;
      that.$axios.post(api + '/site/onlineContact', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          that.qq = res.data.data.qq,
              that.wechat = res.data.data.wechat,
              that.tiktok = res.data.data.tiktok
          console.log(res.data.data);
        } else {
          that.$message.error(res.data.msg);
        }
      })
    },
    //友情链接
    linkList() {
      let that = this;
      that.$axios.post(api + '/site/outsideList', {
        deptId:deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          that.linkData = res.data.data
        } else {
          that.$message.error(res.data.msg);
        }
      })
    },
    //在线咨询提交
    zxSubmit(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.$axios.get(api + '/site/ly?deptId=' + deptId + '&content=' + this.ruleForm.content + '&code=' + this.ruleForm.code + '&phone=' + this.ruleForm.phone + '&uuid=' + this.uuid, {
            emulateJSON: true
          }).then(function (res) {
            // console.log(121212, res);

            if (res.data.code == '0') {
              that.zxDialog = false
              that.cleanForm()
              that.$message.success(res.data.msg);
            } else {
              that.$message.error(res.data.msg);
            }
          })
        }
      })
    },
    // 重新获取表单验证码
    getVerifyCode() {
      // 直接通过src去请求验证码图片 通过Math.random()防止缓存问题
      this.$refs.vcImg.src = api + '/site/captchaImage?uuid=' + 1 + Math.random()
    },
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },
    lmList() {
      let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            var arr = []
            res.data.data.forEach(item => {
              if (item.visible == 0) {
                arr.push(item)
              }
            })
            // console.log(111, arr);
            that.columnData = that.handleTree(arr, 'menuId', 'parentId')
            // console.log('columnData', that.columnData)
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    openfUrl(url) {
      window.open(url)
    },
    openUrl(item) {
      if (item.menuName != "首页") {
        if (item.menuName === "产品世界") {
          window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName)+ '&menuId=' + item.menuId;
        } else {
          window.location = '/#/ejml?id=' + item.menuId + '&name=' + encodeURI(item.menuName);
        }
        window.location.reload();
      } else {
        window.location = '/#/';
        window.location.reload();
      }
    },

    //二级跳转方法
    menuList(item1, id, item2, index) {
      console.log('跳转信息', item1, item2, index);
      // return
      let that = this;
      that.$axios.post(api + '/site/columnDetail', {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (item1.menuType === 'D') {
            window.location = '/#/cplist?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index+ '&menuId=' + item1.menuId;
            window.location.reload();
          } else if (item1.menuType === 'C') {
            console.log(111111,item1.target)
            if(item1.target != ''){
            window.open(api + item1.target)
            }
            window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&target=' + item1.target + '&index=' + index;
            window.location.reload();
          } else if (res.data.data.length > 0) {
            if (item1.menuType === 'F' && item1.perms == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M' && item1.children == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M') {
              window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index;
              window.location.reload();
            } else if (item1.menuType === 'F') {
              window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index;
              window.location.reload();
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },
  }
}
</script>
<style>
/*底部*/
.sjdb{
  display: none;
}
.h_foot1 {
  background: #589d1a;
  padding: 20px 0px;
  color: #aaaaaa;
}
.h_foot1 .h_foot1_in {
  width: 90%;
  max-width: 1280px;
  margin: 0 auto;
  text-align: center;
  line-height: 40px;
}
.h_foot1 .h_foot1_in>p {
  display: inline-block;
  color: #fff;
  font-size: 20px;
  height: 22px;
  line-height: 40px;
  vertical-align: top;
}
.h_foot1 .h_foot1_in a {
  display: inline-block;
  background: #63a81f;
  border-radius: 2px;
  padding: 0px 15px;
  color: #cecece;
  vertical-align: top;
  margin-left: 20px;
  -webkit-transition: all .25s;
  -moz-transition: all .25s;
  -ms-transition: all .25s;
  -o-transition: all .25s;
  transition: all .25s;
}
.h_foot1 .h_foot1_in a:hover {
  background: #407a0d;
  color: #14a2a7;
}
.h_foot1 .h_foot1_in a p {
  float: left;
  color: #fff;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  padding-right: 15px;
  border-right: 1px solid #138488;
}
.h_foot1 .h_foot1_in a span {
  float: left;
  display: block;
  height: 50px;
  line-height: 20px;
  padding-left: 15px;
  border-left: 1px solid #fff;
}
.h_foot1 .h_foot1_in a span:before {
  content: "";
  display: block;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  background: url(../../static/img/right.png) center center no-repeat;
  background-size: cover;
  margin-top: 15px;
}
.h_foot2 {
  background: #1c222a;
  padding: 20px 0px;
  color: #aaaaaa;
}
.h_foot2 .h_foot2_in {
  width: 90%;
  max-width: 1280px;
  margin: 0 auto;
  text-align: center;
  line-height: 24px;
}
.h_foot2 .h_foot2_in a {
  color: #cecece;
}
.h_foot2 .h_foot2_in a:hover {
  color: #14a2a7;
}
/*logo*/
.logobox{
  padding: 0 3%;
}
.searchbox{
  color: #ffffff;
  font-size: 23px;
  line-height: 70px;
  padding: 0 60px;
}
.el-icon-arrow-down:before {
  display: none;
}
.footer {
  background: #6fba2c;
}
.fd-top {
  overflow: hidden;
  padding: 30px 40px;
  display: flex;
}
.fd-logo {
  float: left;
  width: 25%;
  height: 62px;
  line-height: 60px;
}
.fd-logo img {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
}
.fd-nav {
  float: left;
  width: 50%;
}
.fd-nav dl {
  float: left;
  width: 16.66%;
  font-size: 14px;
}
.fd-nav dl dt {
  margin-bottom: 30px;
  color: #fff;
}
.fd-nav dl dd a {
  display: block;
  color: #fff;
  margin-bottom: 10px;
}
.fd-nav dl dd a:hover {
  color: #fff;
}
.fd-qr {
  float: right;
  margin-left: 30px;
}
.fd-qr .pic {
  width: 110px;
  height: 110px;
  overflow: hidden;
}
.fd-qr .pic img {
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
}
.fd-qr h3 {
  text-align: center;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
.footer .copy {
  padding: 20px 0;
  overflow: hidden;
  border-top: 1px solid #63a81f;
  font-size: 14px;
}
.footer .copy p {
  color: #fff;
  text-align: center;
  padding: 8px 0
}
.footer .copy a {
  color: #fff;
}
.footer .copy a:hover {
  color: #fff;
}
.wp {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}
dl, dt, dd {
  margin: 0;
  padding: 0;
}

/*底部*/
.el-input--suffix .el-input__inner {
  background-color: transparent !important;
  color: #ffffff;
}

.copytit {
  padding: 15px 50px 15px 15px;
}

.copyright {
  padding: 30px 0;
  display: flex;
  margin-left: 20%;
}

.msgsname {
  padding: 8px 0;
  font-size: 16px;
  cursor: pointer;
  font-weight: 800;
}
.mas{
  margin-top: 40px;
  height: 80px;
}

.msgtitle {
  padding: 15px 0;
  font-size: 22px;
  font-weight: bolder;
}
.msgtitle1 {
  padding: 55px 0 0 0;
   font-size: 22px;
   font-weight: bolder;
 }

.linkbox {
  padding: 0px 0px 0 20%;
  width:calc(100% / 3 - 35px);
}

.linkbox1 {
  padding: 0px 0px 0 5%;
  width:calc(100% / 3 - 5px);
}


.msgbox {
  padding: 50px 0 40px 0;
  display: flex;
}

.footbox {
  padding: 15px;
  background-image: url("../../static/img/buttonbg.jpg");
  /*!*opacity: 0.5;*!height: 600px;*/
  background-size: 100% 100%;
  color: #ffffff;
}

::v-deep .el-popper[x-placement^=bottom] {
  border: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.menu-top {
  display: flex;
  justify-content: space-between;
}

.menu_item {
  height: 100%;
  line-height: 74px;
  color: #FFFFFF;
}

.menu_centent {
  background: #fff;
  display: flex;
  padding: 0 10px;
  /*margin-top: -20px;*/
}

.item_li {
  line-height: 30px;
  cursor: pointer
}

.item_li:hover {
  color: #0E58A5;
}

.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #77AE2C;
}

.el-menu--horizontal .el-menu .el-menu-item {
  color: #000;
  border-bottom: solid 1px #F3F3F3;
  text-align: center;
}

/*菜单背景颜色*/
.el-menu.el-menu--horizontal {
  background: none;
  border: none;
  display: flex;
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #FFFFFF !important;
  text-align: center;
  height: 40px;
  line-height: 30px;
}

.el-submenu__title {
  color: #FFFFFF !important;
}

.el-menu-item {
  color: #FFFFFF;
}

.el-submenu__title:hover {
  background-color: transparent;
  border-bottom: solid 2px #F3F3F3 !important;

}

.el-menu-demo .el-menu-item:hover {
  background-color: transparent;
  border-bottom: solid 2px #F3F3F3 !important;
  color: #FFFFFF !important;
}

::v-deep .el-form-item__error {
  top: 92%;
}

/*侧边栏*/
.cbtb {
  width: 20px;
  height: 20px;
  background: #ffffff;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border-radius: 2px;
}

.cbbox {
  position: fixed;
  right: 0%;
  top: 50%;
  width: 60px;
  padding: 0px 0px 150px;
  z-index: 999;
}

.el-menu-demo {
  /*text-align: center;*/
  margin: auto;
}

/*侧边栏弹窗*/
.el-popover {
  min-width: auto;
}

.zxbox .el-dialog {
  left: 22% !important;
  margin-top: auto !important;
}

.zxbox .el-dialog__header {
  /*background-color: #009FED;*/
  padding: 0px;
}

.zxbox .el-dialog__title {
  color: #fff;
}

.zxbox .dialog-header-title {
  display: flex;
}

.zxbox .el-dialog__close {
  color: #fff;
}

a {
  text-decoration: none;
  color: #000;
}


.jlimg span:last-child {
  padding: 15px;
}

.ssbox span {
  color: #FFFFFF;
  line-height: 40px;
  padding: 20px;
  color: #ffffff;
}

.el-carousel__item img {
  z-index: 0;
  width: 100%;
  height: 100%;
}

body {
  margin: 0;
}
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.headbox {
  width: 100%;
  /*background-image: linear-gradient(to bottom,rgba(17,84,127,1), transparent);*/
  /*background:#1973D4;*/
  position: relative;
  top: 0;
  margin-bottom: -80px;
  z-index: 555;
}
.el-dropdown {
  display: none;
}
@media screen and (max-width: 500px) {
  .copytit{
    padding: 0;
  }
  .lowerbox{
    padding:19px !important;
    margin-left:0 !important;
  }
  .cpbox{
    width: calc(100% / 2 - 35px) !important;
  }
  .cpimg{
    height: 100% !important;
    width: 100% !important;
  }
  .imgbox{
    width: 90% !important;
  }
  .titleName{
    height: 50px !important;
  }
  .textbox{
    font-size: 14px;
    line-height: 1.4 !important;
  }
  .el-carousel__item img{
    height: 400px !important;
    /*object-fit: contain;*/
  }
  .el-carousel__container{
    height: 400px !important;

  }
  .menu-top{
    display: none;
  }

  .searchbox{
    padding: 0;
  }
  .logobox{
    padding: 0 118px 0px 15px;
  }
  .el-popover {
    width: 300px !important;
    left: 15px !important;
  }
  .el-button--primary{
    color: #008D40;
    background: #fff;
    border-color: #fff;
    border-radius: 30px;
    height: 35px;
    margin: 15px 10px;
  }
  .el-button--primary:focus{
    background: #008D40;
    border-color: #008D40
  }
  .el-dropdown-menu__item{
    text-align: center;
  }
  .el-popper[x-placement^=bottom]{
    top:50px !important;
    left:2% !important;
    width: 95%;
  }
  .el-dropdown {
    display: block;
  }
  .footbox{
    display: none;
  }
  .sjdb{
    display: block;
  }
  .cbbox{
    display: none;
  }
  .mas{
    height: auto;
    margin-top:0;
  }
  .linkbox {
    padding: 0px 0px 0 5%;
    width: 90%;
    color: #FFFFFF;
  }
}
</style>
